import { Form, Input, Button, Upload, Row, Col, Modal, Card, message, Image, Alert } from 'antd';
import { PlusOutlined, ReadOutlined, CloudUploadOutlined } from '@ant-design/icons';
import { useState, useEffect } from "react";
import axios from "axios";
import { useMoralis } from "react-moralis";
import { configs } from "../configs/config";
import { DateTime } from "luxon";
import nftPlaceholderImage from "../assets/nft-placeholder.png"
import { getEllipsisTxt } from "helpers/formatters";
import bscIcon from "../assets/icons/bsc.svg";
import NFTMintedTxList from './NFTMintedTxList';

function NFTMintingForm() {

  const { account, web3, isWeb3Enabled, isAuthenticated, user, enableWeb3  } = useMoralis();

  const styles = {
    nftMintingForm: {
      background: "#050021",
      border: "1px solid #0D0063",
      color: "#FFFFFF !important",
      marginTop:'20px'
    },
  };


  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [nftName, setNftName] = useState('Your Cool NFT Name');
  const [nftDescription, setNftDescription] = useState('Your Cool NFT Description');
  const [fileList, setFileList] = useState([]);
  const [assetImage, setAssetImage] = useState('');
  // const [assetType, setAssetType] = useState('');
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [contractAddress, setContractAddress] = useState('');
  const [contractLink, setContractLink] = useState('');
  const [nftTransactions, setNftTransactions] = useState([]);
  const [processedNftTransactions, setProcessedNftTransactions] = useState([]);
  const [nftMintEligibility, setNftMintEligibility] = useState(false);
  const [accountAddress, setAccountAddress] = useState('');

  useEffect(() => {
    const { nftContractConfig } = configs;
    setContractAddress(nftContractConfig.contractAddress);
    setContractLink(`${nftContractConfig.blockchainNetwork}address/${nftContractConfig.contractAddress}`);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // useEffect(() => {
  //   if (isAuthenticated && accountAddress?.toLowerCase() !== account?.toLowerCase()) {
  //     setAccountAddress(account);
  //   }
  //   if (!isAuthenticated) {
  //     setAccountAddress('');
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [user, account, isAuthenticated, accountAddress, isWeb3Enabled]);

  useEffect(() => {
    setAccountAddress(user?.attributes.ethAddress);
    const connectorId = window.localStorage.getItem("connectorId");
    if(connectorId === "injected"){
      if(accountAddress?.toLowerCase() !== account?.toLowerCase()){
        setAccountAddress(account);
        return;
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, account]);

  useEffect(() => {
    const connector = window.localStorage.getItem("connectorId");
    
    if(connector === 'walletconnect' && isAuthenticated){
      setNftMintEligibility(true);
    } else if(connector === 'injected' && isAuthenticated){
      setNftMintEligibility(true);
    }else{
      setNftMintEligibility(false);
    }
  }, [isAuthenticated, user])

  const onFormFieldChange = (fields) => {
    setNftName(fields[0].value);
    setNftDescription(fields[1].value);
  }
  const onFinish = async (values) => {

    console.log('accountAddress 1', accountAddress);
    console.log('is authenticate', isAuthenticated);
    if(!isWeb3Enabled){
      console.log('called');
      const connector = window.localStorage.getItem("connectorId");
      enableWeb3({ provider: connector});
    }

    const connector = window.localStorage.getItem("connectorId");
    enableWeb3({ provider: connector});

    console.log('isWeb3Enabled Minting ', isWeb3Enabled);
    console.log('connector Minting ', window.localStorage.getItem("connectorId"));
    // const result = await web3.eth.personal.sign('Hello world', user.get('ethAddress'));
    // console.log('test txn called ', result);
    try{
      setLoading(true);
      const metaData =  createMetaDataFile(values);
      const response = await uploadMetaDataFile(metaData);
      
      if(response.status === 200){
        const ipfsHash = response.data.IpfsHash || '';
        const metaDataURI = "ipfs://" + ipfsHash;
        
        console.log('accountAddress 2', accountAddress);
        const { nftContractConfig } = configs;
        const nftAddress = nftContractConfig.contractAddress;
        const nftContractABI = JSON.parse(nftContractConfig.contractABI);
        const nftContractInstance = await new web3.eth.Contract(nftContractABI, nftAddress);
        const nftMintedResult = await nftContractInstance.methods
          .safeMint(accountAddress, metaDataURI)
          .send({ 
            gasLimit: nftContractConfig.estimatedGasFeeLimit.toString(),
            to: nftAddress,
            from: accountAddress.toLowerCase(),
            value: nftContractConfig.constInWeiForSingleMint, 
          });
        
        console.log('from',accountAddress)
        //store minted result into the transaction array
        let transactionsList = [...nftTransactions, nftMintedResult];
        setNftTransactions(transactionsList);
        const processedList = processTableData(transactionsList);
        setProcessedNftTransactions(processedList);
        message.success(`NFT has been minted your tx hash is : ${nftMintedResult.transactionHash}`);
        restTheFormState();
      }
    }catch(error){
      message.error("Something went wrong while minting the NFT ", error.message || '');
      console.error("minting error", error);
    }finally{
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.error("error on form submit ", errorInfo);
    message.error("Please check your input details");
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  const props = {
    name: 'file',
    action: 'https://api.pinata.cloud/pinning/pinFileToIPFS',
    headers: {
      pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
      pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_KEY
    },
  }

  const restTheFormState = () => {
    form.resetFields();
    setAssetImage('');
    setPreviewImage('');
    setPreviewTitle('');
    setPreviewVisible(false);
    setFileList([]);
    setNftName('Your Cool NFT Name');
    setNftDescription('Your Cool NFT Description');
  }

  const createMetaDataFile = (data) => {

    const timestamp = DateTime.now();
    const { ts } = timestamp;
    const fileName = `hodl4gold-metadata-${ts}.json`;

    const metadata = {
      name: fileName
    }

    const content = {
      name: data.name,
      description: data.description,
      image: data.ipfsURI,
      attributes: [],
    }

    const payload = {
      pinataMetadata: metadata,
      pinataContent: content,
    }

    return payload;
  }

  const uploadMetaDataFile = async (metaDataJson) => {

    try{
      const endpoint = "https://api.pinata.cloud/pinning/pinJSONToIPFS";
      const options = {
        headers : {
          pinata_api_key: process.env.REACT_APP_PINATA_API_KEY,
          pinata_secret_api_key: process.env.REACT_APP_PINATA_SECRET_KEY
        }
      }
      const response = await axios.post(endpoint, metaDataJson, options);
      message.success(`Your metadata file has been uploaded to IPFS node your CID : ${response.data.IpfsHash}`);
      return response;
    }catch(error){
      console.error("metadata upload error", error);
      message.error("Error while uploading your metadata file into IPFS server");
    }
   
  }

  const handlePreview =  async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    const preview = file.url || file.preview;
    setPreviewImage(preview);
    setPreviewVisible(true);
    const title = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
    setPreviewTitle(title);
  }

  const handleChange = (info) => {
    const { fileList, file } = info;
    const { response }  = file;
    if(response && fileList.length > 0){
      const ipfsURI = "ipfs://" + response.IpfsHash;
      const previewImage = `https://gateway.pinata.cloud/ipfs/${response.IpfsHash}?preview=1`;
      setAssetImage(previewImage);
      form.setFieldsValue({ ipfsURI });
      message.success(`Your asset has been uploaded to IPFS node your CID : ${response.IpfsHash}`)
    }else{
      setAssetImage('');
    }
    setFileList(fileList);
  }

  const handleCancel = () => {
    setPreviewVisible(false);
  }

  const processTableData = (nftTransactions) => {
    //append new transaction to the existing object
    let processedTxList = [];
    for (let i =0; i < nftTransactions.length; i++) {
      const payload = {
        key :  i+1,
        block: nftTransactions[i].blockNumber,
        transactionHash: nftTransactions[i].transactionHash,
        mintedBy: nftTransactions[i].to,
      }

      processedTxList.push(payload);;
    }

    return processedTxList;
  }

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <div>
      <Row gutter={20}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Card style={styles.nftMintingForm} className="nft-form-metadata-container">
            <Form
              layout='vertical'
              form={form}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              onFieldsChange={(_, allFields) => {onFormFieldChange(allFields)}}
            >
              <Form.Item 
                label="Name"
                name="name"
                tooltip="The name of your very own NFT" 
                required
                rules={[{ required: true, message: 'Please enter the name of your NFT' }]}
              >
                <Input prefix={<ReadOutlined className="site-form-item-icon" />} placeholder="Name of the NFT" />
              </Form.Item>
              <Form.Item 
                label="Description"
                name="description"
                required
                tooltip="The description of your very own NFT"
                rules={[{ required: true, message: 'Please enter the description of your NFT' }]}
              >
                <Input.TextArea showCount  prefix={<ReadOutlined className="site-form-item-icon" />} placeholder="Description of your NFT" />
              </Form.Item>

              <Form.Item 
                label="Upload your NFT Asset"
                name="asset"
                required tooltip="Upload your asset using .jpg .png .gif format"
                rules={[{ required: true, message: 'Please upload your asset' }]}
              >
                
                <Upload
                    {...props}
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                  >
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
              </Form.Item>
                <Modal
                  visible={previewVisible}
                  title={previewTitle}
                  onCancel={handleCancel}
                  footer={null}
                >
                    <img alt="images" style={{ width: '100%' }} src={previewImage} />
                </Modal>

              <Form.Item 
                label="IPFS Assest URI"
                name="ipfsURI"
                tooltip="ipfs asset uri use for extracting your nft data" 
                required
                rules={[{ required: true, message: 'Please upload your asset to auto populate this field' }]}
              >
                <Input prefix={<CloudUploadOutlined className="site-form-item-icon" />}  placeholder="Upload your asset to auto populate this field" readOnly />
              </Form.Item>

              <Row>
                { JSON.stringify(processedNftTransactions) }
                {
                  (nftMintEligibility) ?
                      <Col span={24} className="nft-minting-btn">
                        <Form.Item>
                          <Button 
                            type="primary" 
                            htmlType="submit" 
                            className="mint-nft-button" 
                            loading={loading}
                            style={{ width: '300px'}}
                          >
                            Mint your NFT
                          </Button>
                        </Form.Item>
                    </Col>
                    : <Col span={24} className="nft-minting-btn">
                        <Alert message="Please connect your wallet and switch your network to BSC to mint your NFT" type="warning"  />
                      </Col>
                }
             
              </Row>
            </Form>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Card style={styles.nftMintingForm} className="nft-form-metadata-container">
            <Row>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <div className="nft-image-container">
                  <Image
                    style={{ borderRadius: '20px'}}
                    preview={false}
                    fallback={nftPlaceholderImage}
                    src={assetImage}
                  />
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <div className="nft-info-container" style={{ padding: '5px 20px'}}>
                  <div 
                    className="nft-title"
                    style={{ 
                      color: '#FFFFFF', 
                      fontSize: '20px',
                    }}
                  >
                    {nftName}
                  </div>
                  <div 
                    className="nft-description"
                    style={{ 
                      color: '#FFFFFF', 
                      fontSize: '13px',
                    }}
                  >
                    {nftDescription}
                  </div>
                </div>

                <div className="nft-details" style={{ padding: '5px 20px'}}>
                  <div className="nft-data" style={{ fontSize: '12px', fontWeight: '600'}}>
                    Contract Address
                  </div> 
                  <div className="nft-value">
                    <a href={contractLink} target="_blank" rel="noreferrer">
                      {getEllipsisTxt(contractAddress, 12)}
                    </a>
                  </div>  
                </div>

                <div className="nft-details" style={{ padding: '5px 20px'}}>
                  <div className="nft-data" style={{ fontSize: '12px', fontWeight: '600'}}>
                    Blockchain
                  </div> 
                  <div className="nft-value" style={{ display: 'flex'}}>
                    <Image src={bscIcon} width="20px" height="20px" preview={false} />
                    <span style={{paddingLeft: '5px'}}>{ configs.nftContractConfig.networkType }</span>
                  </div>  
                </div>

                <div className="nft-details" style={{ padding: '5px 20px'}}>
                  <div className="nft-data" style={{ fontSize: '12px', fontWeight: '600'}}>
                    Token Standard
                  </div> 
                  <div className="nft-value">
                    <span>{ configs.nftContractConfig.tokenStandard }</span>
                  </div>  
                </div>

                <div className="nft-details" style={{ padding: '5px 20px'}}>
                  <div className="nft-data" style={{ fontSize: '12px', fontWeight: '600'}}>
                    Owned By
                  </div> 
                  <div className="nft-value">
                    <span>
                      {(accountAddress) ? getEllipsisTxt(accountAddress, 12) : "N/A"}
                    </span>
                  </div>  
                </div>
              </Col>
            </Row>

            {/* transaction details section */}
            <Row>
              <Col span={24}>
                <div className="transaction-details-title" style={{ padding: '5px 10px'}}>
                  <NFTMintedTxList transactionList={processedNftTransactions} style={{marginTop: '50px'}} />
                </div>
              </Col>
            </Row>
          </Card>
        </Col> 
      </Row>
    
    </div>
  );
}

export default NFTMintingForm;
